<script lang="ts">
  // Draws one report template at full size (see REPORT_SIZES).
  import { createContext, normalizeOptions } from './context'
  import { TEMPLATES_BY_ID, templateAvailable, templatesFor } from './registry'
  import type { ReportData, ReportOptions } from './types'

  export let data: ReportData
  export let templateId: string
  export let options: Partial<ReportOptions> | null = null

  // Templates assume their report type's data is present (Leaderboard needs a group session,
  // not just a group ride). A saved design can be asked for on an activity without it, so fall
  // back to another template of the type that works, then to the always-available Route.
  $: def = (() => {
    const wanted = TEMPLATES_BY_ID[templateId]
    if (wanted && templateAvailable(wanted, data)) return wanted
    return (wanted && templatesFor(wanted.type).find((t) => templateAvailable(t, data))) ?? TEMPLATES_BY_ID['activity-route']
  })()
  $: ctx = createContext(def, data, normalizeOptions(def, options))
</script>

<svelte:component this={def.component} {ctx} />
